import React from 'react';
import { Spinner } from 'react-bootstrap';
import { CheckCircle, Circle, PartyPopper } from 'lucide-react';

const CompletionStep = ({ completedSteps, onComplete, saving, steps }) => {
    const checklistItems = [
        { key: steps.COMPANY_DETAILS, label: 'Företagsuppgifter' },
        { key: steps.FISCAL_YEAR, label: 'Räkenskapsår' },
        { key: steps.LOGO, label: 'Logotyp' },
    ];

    return (
        <>
            <style>{`
                .completion-step {
                    text-align: center;
                    padding: 1rem 0;
                }
                .completion-icon {
                    width: 64px;
                    height: 64px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, var(--primary), var(--rgba-primary-7));
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 1.5rem;
                    color: white;
                }
                .completion-title {
                    font-size: 1.5rem;
                    font-weight: 700;
                    color: #1e293b;
                    margin-bottom: 0.5rem;
                }
                .completion-subtitle {
                    font-size: 0.95rem;
                    color: #64748b;
                    margin-bottom: 2rem;
                }
                .completion-checklist {
                    max-width: 350px;
                    margin: 0 auto 2rem;
                    text-align: left;
                }
                .completion-item {
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    padding: 0.75rem 1rem;
                    border-radius: 10px;
                    margin-bottom: 0.5rem;
                    background: #f8fafc;
                }
                .completion-item.done {
                    background: var(--rgba-primary-1);
                }
                .completion-item-icon {
                    flex-shrink: 0;
                }
                .completion-item-label {
                    font-size: 0.9rem;
                    font-weight: 500;
                    color: #374151;
                }
                .completion-item.done .completion-item-label {
                    color: var(--primary);
                }
                .completion-item.skipped .completion-item-label {
                    color: #94a3b8;
                }
                .completion-go-btn {
                    background: var(--primary);
                    border: none;
                    color: white;
                    padding: 0.75rem 2.5rem;
                    border-radius: 10px;
                    font-weight: 600;
                    font-size: 1rem;
                    cursor: pointer;
                    transition: all 0.15s;
                    display: inline-flex;
                    align-items: center;
                    gap: 0.5rem;
                }
                .completion-go-btn:hover:not(:disabled) {
                    opacity: 0.9;
                    transform: translateY(-1px);
                }
                .completion-go-btn:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }
                .completion-hint {
                    font-size: 0.8rem;
                    color: #94a3b8;
                    margin-top: 1rem;
                }
            `}</style>
            <div className="completion-step">
                <div className="completion-icon">
                    <CheckCircle size={28} />
                </div>
                <h2 className="completion-title">Bra jobbat!</h2>
                <p className="completion-subtitle">
                    Du har konfigurerat ditt företag. Här är en sammanfattning:
                </p>
                <div className="completion-checklist">
                    {checklistItems.map(item => {
                        const isDone = completedSteps.includes(item.key);
                        return (
                            <div key={item.key} className={`completion-item ${isDone ? 'done' : 'skipped'}`}>
                                <span className="completion-item-icon">
                                    {isDone ? (
                                        <CheckCircle size={20} className="text-primary" style={{ color: 'var(--primary)' }} />
                                    ) : (
                                        <Circle size={20} color="#cbd5e1" />
                                    )}
                                </span>
                                <span className="completion-item-label">
                                    {item.label}
                                    {!isDone && <span style={{ fontSize: '0.75rem', marginLeft: '0.5rem' }}>(kan göras senare)</span>}
                                </span>
                            </div>
                        );
                    })}
                </div>
                <button
                    className="completion-go-btn"
                    onClick={onComplete}
                    disabled={saving}
                >
                    {saving ? (
                        <Spinner animation="border" size="sm" />
                    ) : (
                        'Gå till Dashboard'
                    )}
                </button>
                <p className="completion-hint">
                    Du kan alltid ändra dessa inställningar under Inställningar.
                </p>
            </div>
        </>
    );
};

export default CompletionStep;
